/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcDtcFilesV1FileRequestEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_DTC_FILES_V1_FILE_REQUEST_EVENT_ENTITY_NAME = 'exc.dtc.files.v1.FileRequestEvent';
export const excDtcFilesV1FileRequestEventEntity = new schema.Entity<ExcDtcFilesV1FileRequestEvent>(EXC_DTC_FILES_V1_FILE_REQUEST_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcDtcFilesV1FileRequestEvent) => `${entity.metadata?.eventId}` });

